// import { API_BASE_URL } from '../utils/constants';
import { API_BASE_URL } from '../../utils/constants';

export async function fetchTaxStatus(token) {
  const response = await fetch(`${API_BASE_URL}/api/customer/tax-status?token=${encodeURIComponent(token)}`);
  if (!response.ok) {
    throw new Error('Failed to fetch tax status');
  }
  return response.json();
}